<template>
    <div v-if="radio1 === $t('Publish.Edit.Index.Images')">
        <div class="imageBatchQuantity">
            <el-checkbox v-model="imagesBatch" style="margin-right: 10px" @change="imagesBatchChange">{{ mediaSelectedNum }} {{ $t('Publish.Edit.Components.ImageList.MediaSelected') }}</el-checkbox>
            <!-- <el-button type="text"></el-button> -->
        </div>
        <div class="f fw-w" v-if="imageList.length">
        <!-- 新增的key为imgUrl,编辑的key为src -->
            <div v-for="(item, index) in imageList" :key="index" style="position: relative" class="imagesItem" @click="imageItemClick(item)" :class="{imagesItemChoose: item.isChecked}">
                <el-image :src="item.src || item.imgUrl" style="width: 140px;height: 140px;"></el-image>
                <div class="imagesItem_mask" v-if="item.isChecked || item.disabled" :class="{mask_disabled: item.status === 1 || item.variantIds, skuNoChoose: item.disabled }"></div>
                <div class="imagesItem_check" v-if="item.isChecked">
                    <i class="el-icon-check" style="color: #ffffff;font-size: 24px"></i>
                </div>
            </div>
        </div>
        <el-empty :description="$t('publishEdit.NoPictures')" v-else></el-empty>
        <div v-if="imageList.length">
            -- {{ pageTip }}
        </div>
    </div>
</template>

<script>
export default {
  props: {
    imageList: {
      type: Array,
      default: () => []
    },
    radio1: {
      type: String,
      default: () => ''
    },
    platformCode: {
      type: String,
      default: () => 'SP'
    }
  },
  data() {
    return {
      imagesBatch: true
    }
  },
  computed: {
    mediaSelectedNum() {
      let numArr = this.imageList.filter(e => {
        let final = e.isChecked
        if (e.disabled) final = false
        return final
      })
      return numArr.length
    },
    pageTip() {
      let tip = ''
      if (this.platformCode === 'SL') {
        tip = this.$t('publishEdit.tips5')
      } else {
        tip = this.$t('publishEdit.tips4')
      }
      return tip
    }
  },
  methods: {
    // 图片批量勾选
    imagesBatchChange(value) {
      if (this.platformCode === 'TT' && value) {
        this.$message.warning(this.$t('publishEdit.tips8'))
      }
      this.imageList.forEach((item, i) => {
        if (item.status && item.status === 1) return
        if (item.variantIds) return
        if (item.disabled) return
        if (this.platformCode === 'TT') this.$set(item, 'isChecked', i >= 9 ? false : value)
        else this.$set(item, 'isChecked', value)
      })
    },
    // 图片点击勾选取消
    imageItemClick(item) {
      if (this.platformCode === 'TT' && this.mediaSelectedNum >= 9 && !item.isChecked) {
        return this.$message.warning(this.$t('publishEdit.tips8'))
      }
      if (item.status && item.status === 1) return
      if (item.variantIds) return
      if (item.disabled) return
      this.$set(item, 'isChecked', !item.isChecked)
    },
    // 新增状态下  获取顶部主图
    skuChangeProductImageUrl() {
      this.$nextTick(() => {
        const target = this.imageList.find(e => e.status === 1 && e.isChecked)
        let imageUrl = ''
        if (target) {
          imageUrl = target.imgUrl || target.imageUrl
        } else {
          imageUrl = ''
        }
        return imageUrl
      })
    },
    // variants选中images增加删除图片事件
    imagesLinkage(row) {
      if (row.isChecked) {
        row.images.forEach((img, index) => {
          // 图片默认勾选
          this.$set(img, 'isChecked', index < 6)
          img.disabled = false
          // 首次加载时判断，没有则push进去   addkey为手动添加唯一标识
          this.imageList.every(e => e.addkey !== `${img.imgUrl}${row.skuCode}`) && this.imageList.push(img)
        })
      } else {
        row.images.forEach(img => {
          let target = this.imageList.find(e => e.addkey === `${img.imgUrl}${row.skuCode}`)
          if (target) {
            target.isChecked = false
            this.$set(target, 'disabled', true)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.imagesItem {
    position: relative;
    cursor: pointer;
    border: 2px solid transparent;
    margin: 0 12px 12px 0;
    padding: 1px;
    .imagesItem_mask {
        position: absolute;
        top: 0;
        right: 0px;
        width: 140px;
        height: 140px;
        background-color: #99C41C;
        opacity: .1;
    }
    .mask_disabled {
      background-color: #99C41C;
      opacity: .3;
      cursor: not-allowed;
      z-index: 1;
    }
    .skuNoChoose {
      background-color: #e8e8e8;
      opacity: .9;
      cursor: not-allowed;
      z-index: 1;
    }
    .imagesItem_check {
        position: absolute;
        width: 30px;
        height: 30px;
        top: -2px;
        right: -2px;
        background: #99C41C;
        border-radius: 0 0 0 30px;
        padding: 2px 0 0 6px;
    }
}
.imagesItem:hover {
  border-color: #CDD4DD;
}
.imagesItemChoose {
  border-color: #CDD4DD;
}
</style>
